import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { Grid, TextField, Typography, FormControlLabel, FormHelperText, Checkbox, Dialog } from '@material-ui/core';
import { useFormik } from 'formik';
import Modal from 'components/Modal';
import Input from 'components/Input';
import Select from 'components/Select';
import Button from 'components/Button';
import WarningMessage from 'components/WarningMessage';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { removeOs } from '../../store/thunk';

import { validations, modalValidations } from './validations';

export default function RemoveOS() {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { selects } = useSelector(state => state.filters);
  const { isLoading } = useSelector(state => state.advancedConfigs);

  const osSituations = selects
    ?.find(filter => filter?.id == 'operationSituation')
    ?.options;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: validations,
    initialValues: {
      startDate: moment(moment.now()).format('YYYY-MM-DD'),
      endDate: moment(moment.now()).format('YYYY-MM-DD'),
      situation: ''
    },
    onSubmit: () => setIsModalOpen(true)
  });

  const modalFormik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: modalValidations,
    initialValues: {
      reason: '',
      password: '',
      passwordConfirm: '',
      actionConsent: false
    },
    onSubmit: values => {
      const params = {
        reason: values?.reason,
        userPassword: values?.password,
        startDate: formik?.values?.startDate,
        endDate: formik?.values?.endDate,
        situationId: formik?.values?.situation
      }

      dispatch(removeOs(userId, establishmentId, params)).then(() => {
        setIsModalOpen(false);
        setIsSuccessModalOpen(true);
      });
    }
  });

  return(
    <Grid container>
      {isSuccessModalOpen && (
        <Modal
          maxWidth='sm'
          title='Operação realizada'
          open={isSuccessModalOpen}
          onClose={() => setIsSuccessModalOpen(false)}
        >
          <Typography>
            Dependendo do período escolhido a operação pode demorar até 24hrs para ser realizada em todas as OSs.
          </Typography>
        </Modal>
      )}
      {isModalOpen && (
        <Dialog
          id='remove-os-advanced-config-modal'
          scroll='body'
          maxWidth='lg'
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <Grid container spacing={2} style={{ padding: 30 }}>
            <Grid item xs={12}>
              <WarningMessage
                justifyContent="flex-start"
                message="Essa ação não poderá ser desfeita!"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Confirmo que vou remover todas as Ordens de Serviço no estado de <b>{osSituations?.find(situation => situation?.value == formik.values.situation)?.label || ''}</b>
                <br />
                do dia <b>{moment(formik.values.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b> até o dia <b>{moment(formik.values.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <form onSubmit={modalFormik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8}>
                    <Input
                      name="reason"
                      type="text"
                      label="Motivo"
                      value={modalFormik.values.reason}
                      error={modalFormik.errors.reason}
                      helperText={modalFormik.errors.reason}
                      onChange={modalFormik.handleChange}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Input
                      name="password"
                      type="password"
                      label="Informe sua senha"
                      value={modalFormik.values.password}
                      error={modalFormik.errors.password}
                      helperText={modalFormik.errors.password}
                      onChange={modalFormik.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Input
                      name="passwordConfirm"
                      type="password"
                      label="Repita sua senha"
                      value={modalFormik.values.passwordConfirm}
                      error={modalFormik.errors.passwordConfirm}
                      helperText={modalFormik.errors.passwordConfirm}
                      onChange={modalFormik.handleChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      labelPlacement='end'
                      label={
                        <Typography color='primary'>
                          Estou ciente que esta ação não poderá ser desfeita
                        </Typography>
                      }
                      control={
                        <Checkbox
                          checked={modalFormik.values.actionConsent}
                          onChange={event => modalFormik.setFieldValue('actionConsent', event.target.checked)}
                        />
                      }
                    />
                    {!!modalFormik.errors.actionConsent && (
                      <FormHelperText error>
                        {modalFormik.errors.actionConsent}
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <Button
                      type="button"
                      variant="outlined"
                      color="tertiary"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Voltar
                    </Button>
                    <Button
                      type="submit"
                      color="success"
                      loading={isLoading}
                    >
                      Remover
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Dialog>
      )}
      <Grid xs={12}>
        <Typography color="primary" variant="subtitle2" style={{ borderBottom: '1px solid #E4E7EA' }}>
          Remover as Ordens de Serviços
        </Typography>
      </Grid>
      <Grid xs={12}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ marginTop: 30 }}>
                Escolha o período de entrada dos veículos que deseja remover
              </Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  inputFormat="DD/MM/YYYY"
                  label="Data início"
                  value={formik.values.startDate}
                  onChange={date => formik.setFieldValue('startDate', moment(date).format('YYYY-MM-DD'))}
                  renderInput={params => (
                    <TextField
                      {...params}
                      fullWidth
                      name="startDate"
                      variant='outlined'
                      error={formik.errors.startDate}
                      helperText={formik.errors.startDate}
                      inputProps={{
                        ...params.inputProps
                      }}
                      SelectProps={{
                        MenuProps: {
                          disableEnforceFocus: true
                        }
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  inputFormat="DD/MM/YYYY"
                  label="Data fim"
                  value={formik.values.endDate}
                  onChange={date => formik.setFieldValue('endDate', moment(date).format('YYYY-MM-DD'))}
                  renderInput={params => (
                    <TextField
                      {...params}
                      fullWidth
                      name="endDate"
                      variant='outlined'
                      error={formik.errors.endDate}
                      helperText={formik.errors.endDate}
                      inputProps={{
                        ...params.inputProps
                      }}
                      SelectProps={{
                        MenuProps: {
                          disableEnforceFocus: true
                        }
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                Escolha a situação das OS que deseja remover
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Select
                name="situation"
                label="Escolher situação das OS"
                options={osSituations}
                value={formik.values.situation}
                error={formik.errors.situation}
                helperText={formik.errors.situation}
                onChange={event => formik.setFieldValue('situation', event.target.value)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                type="submit"
                color="success"
              >
                Avançar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
}